import type { BulkUpdateScheduleLessonsRequestParams } from './types';
import { api } from '../api';

export const timetablesApi = api.injectEndpoints({
  endpoints: (build) => ({
    bulkUpdateScheduleLessons: build.mutation<void, BulkUpdateScheduleLessonsRequestParams>({
      query: ({ timetableId, ...body }) => ({
        url: `timetables/${timetableId}/lessons/bulk-update`,
        method: 'POST',
        body,
        responseHandler: 'text',
      }),
    }),
  }),
});

export const { useBulkUpdateScheduleLessonsMutation } = timetablesApi;
